import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

// Automatically inject JWT Bearer token into outgoing API requests if token exists
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token && config.url && (config.url.startsWith(API_BASE_URL) || config.url.startsWith('/'))) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Global response interceptor to handle session expiry
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      if (localStorage.getItem('token') && window.location.pathname.toLowerCase().includes('/admin')) {
        localStorage.removeItem('token');
        alert('Your administrator session has expired or is unauthorized. Please log in again.');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default API_BASE_URL;
